export default class RoleManagement {

    static agent_roles = ["Field Agent", "Call Center Agent"];

    public static isAgent(user_role: string|null): boolean {
        if(user_role) {
            return this.agent_roles.includes(user_role);
        }
        return false;
    }

    public static isAdmin(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Admin";
        }
        return false;
    }
    public static isSupervisor(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Supervisor";
        }
        return false;
    }
    public static isManager(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Manager";
        }
        return false;
    }
    public static isTeamLead(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Team Lead";
        }
        return false;
    }
    public static isSuperAdmin(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Super Admin";
        }
        return false;
    }

    public static isAuditor(user_role: string|null): boolean {
        if(user_role) {
            return user_role === "Auditor";
        }
        return false;
    }

    public static isClient(ownerType: string|null): boolean {
        if(ownerType) {
            return ownerType === "Client";
        }
        return false;
    }

    public static isAgency(ownerType: string|null): boolean {
        if(ownerType) {
            return ownerType === "Agency";
        }
        return false;
    }
}